import { z } from 'zod';

export const ProductivityQuerySchema = z
  .object({
    from: z.iso.datetime(),
    to: z.iso.datetime(),
  })
  .refine((value) => Date.parse(value.from) <= Date.parse(value.to), {
    message: 'from must be less than or equal to to',
    path: ['from'],
  });
export type ProductivityQuery = z.infer<typeof ProductivityQuerySchema>;

export const ProductivityPersonSchema = z.object({
  userId: z.uuid(),
  workedMinutes: z.number().int().nonnegative(),
  paidMinutes: z.number().int().nonnegative(),
  productivityBps: z.number().int().nullable(),
});
export type ProductivityPerson = z.infer<typeof ProductivityPersonSchema>;

export const ProductivityUnscheduledSchema = z.object({
  userId: z.uuid(),
  workedMinutes: z.number().int().nonnegative(),
});
export type ProductivityUnscheduled = z.infer<typeof ProductivityUnscheduledSchema>;

export const ProductivityTotalsSchema = z.object({
  workedMinutes: z.number().int().nonnegative(),
  paidMinutes: z.number().int().nonnegative(),
  productivityBps: z.number().int().nullable(),
});
export type ProductivityTotals = z.infer<typeof ProductivityTotalsSchema>;

export const ProductivityReportSchema = z.object({
  periodBasis: z.literal('TIME_ENTRY_STARTED'),
  from: z.iso.datetime(),
  to: z.iso.datetime(),
  totals: ProductivityTotalsSchema,
  byPerson: z.array(ProductivityPersonSchema),
  unscheduled: z.array(ProductivityUnscheduledSchema),
});
export type ProductivityReport = z.infer<typeof ProductivityReportSchema>;
